<script setup>
import Board from "@/views/trackers/tracker/Board.vue";
import TaskPlate from "@/views/projects/TaskPlate.vue";
import projectsTasksService from "@/services/projects-tasks.service";
import {inject, provide, ref, watch} from "vue";

const emit = defineEmits(['showTask', 'addTask']);
const project = inject('tracker').value;
const serverFilters = inject("serverFilters");
const tasksListUpdated = inject("tasksListUpdated");
const filteredCompaniesCount = inject("filteredCompaniesCount");
const filtersApplied = inject("filtersApplied");

const board = ref(null);
const currentTask = ref(null);

watch(tasksListUpdated, (value) => {
    if (value) {
        board.value.reset();
    }
});

watch(serverFilters, () => {
    board.value.reset();

    if (!filtersApplied.value) {
        filteredCompaniesCount.value = null;
    }
});

function getStagesData() {
    return projectsTasksService.getStagesData(project.id, {filters: serverFilters.value});
}

function getStageTasks(stageId, stageLastLinkId = 0) {
    return projectsTasksService.getStageTasks(project.id, stageId, stageLastLinkId, {filters: serverFilters.value})
}

function saveStageTasks(changedItems) {
    return projectsTasksService.saveStageTasks(project.id, {stagesTasks: changedItems});
}

function countChanged(count) {
    if (filtersApplied.value) {
        filteredCompaniesCount.value = count;
    }
}

function showTask(task) {
    currentTask.value = task;
    emit('showTask', task.id)
}

async function updateTask() {
    const {data} = await projectsTasksService.getTaskPlateData(currentTask.value.id);

    for (let field in data) {
        currentTask.value[field] = data[field];
    }
}

provide('getStagesData', getStagesData);
provide('getStageItems', getStageTasks);
provide('saveFunnelChanges', saveStageTasks);

defineExpose({
    updateTask
})
</script>

<template>
    <div>
        <Board
            ref="board"
            @countChanged="countChanged"
        >
            <template #item="{item: task}">
                <TaskPlate
                    :task="task"
                    @clicked="showTask(task)"
                />
            </template>

            <template #addLink="{stageId}">
                <a class="button-oblong" @click="emit('addTask', stageId)">
                    + Add Task
                </a>
            </template>
        </Board>
    </div>
</template>

<style scoped>

</style>
